import { render, staticRenderFns } from "./ChatConfig.vue?vue&type=template&id=0cae9908&scoped=true"
import script from "./ChatConfig.vue?vue&type=script&lang=js"
export * from "./ChatConfig.vue?vue&type=script&lang=js"
import style0 from "./ChatConfig.vue?vue&type=style&index=0&id=0cae9908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae9908",
  null
  
)

export default component.exports